/* Copyright 2020 cpke
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by cpke <cryptio@pm.me>, December 2020
 */

import React from "react";
import { Route, Switch } from "react-router-dom";
import jwt from 'jwt-decode';
import UnauthenticatedRoute from './UnauthenticatedRoute';
import AuthenticatedRoute from './AuthenticatedRoute';
import AdministrativeRoute from './AdministrativeRoute';
import Home from "./containers/Home";
import Login from "./containers/Login";
import Apps from "./containers/dashboard/Apps";
import NotFound from "./containers/NotFound";
import Licenses from "./containers/dashboard/Licenses";
import Files from "./containers/dashboard/Files";
import Users from "./containers/dashboard/Users";
import Keys from "./containers/dashboard/Keys";
import Variables from './containers/dashboard/Variables';
import Register from "./containers/Register";
import Renew from './containers/Renew';

export default function Routes() {
    const token = localStorage.getItem("token");

    let isAuthenticated = false;
    let isAdmin = false;
    
    if (!token) {
        isAuthenticated = false;
    } else {
        const jTok = JSON.parse(token);

        if (jTok.expires_at <= Math.ceil(Date.now() / 1000)) {
            localStorage.clear();
            
            isAuthenticated = false;
        } else {
            isAuthenticated = true;

            //const tokenDetails = jwt(jTok.access_token);
            //isAdmin = tokenDetails.admin;
            isAdmin = true;
        }
    }

    return (
        <Switch>
            <Route exact path="/">
                <Home />
            </Route>
            <UnauthenticatedRoute exact path="/login" component={Login} appProps={{ isAuthenticated }} />
            <UnauthenticatedRoute exact path="/register" component={Register} appProps={{ isAuthenticated }} />
            <UnauthenticatedRoute exact path="/renew" component={Renew} appProps={{ isAuthenticated }} />

            <AdministrativeRoute exact path="/dashboard/apps" component={Apps} appProps={{ isAuthenticated }} />
            <AdministrativeRoute exact path="/dashboard/keys" component={Keys} appProps={{ isAuthenticated }} />
            <AdministrativeRoute exact path="/dashboard/users" component={Users} appProps={{ isAuthenticated }} />
            <AdministrativeRoute exact path="/dashboard/licenses" component={Licenses} appProps={{ isAuthenticated }} />
            <AdministrativeRoute exact path="/dashboard/files" component={Files} appProps={{ isAuthenticated }} />
            <AdministrativeRoute exact path="/dashboard/variables" component={Variables} appProps={{ isAuthenticated }} />
            {/* Catch all unmatched routes */}
            <Route>
                <NotFound />
            </Route>
        </Switch>
    );
}



// WEBPACK FOOTER //
// ./src/Routes.js